import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { useLanguageDetection } from '@/hooks/useLanguageDetection';

const languages = [
  { code: 'en', name: 'English', label: 'EN' },
  { code: 'fr', name: 'Français', label: 'FR' },
];

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const { getBrowserLanguage, detectedLanguage } = useLanguageDetection();

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];
  const browserLanguage = getBrowserLanguage();

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center gap-2 min-w-[60px]">
          <span className="font-medium text-sm">{currentLanguage.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={`flex items-center gap-2 cursor-pointer ${
              i18n.language === language.code ? 'bg-accent' : ''
            }`}
          >
            <span className="font-medium">{language.label}</span>
            <span>{language.name}</span>
          </DropdownMenuItem>
        ))}
        
        {process.env.NODE_ENV === 'development' && (
          <>
            <DropdownMenuSeparator />
            <div className="px-2 py-1 text-xs text-muted-foreground">
              <div>Browser: {browserLanguage}</div>
              <div>Detected: {detectedLanguage}</div>
              <div>Current: {i18n.language}</div>
            </div>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 